export default function () {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7177_93583)">
                <path
                    d="M27 22.8L27 9.2C27 8.53726 26.4627 8 25.8 8L22.2 8C21.5373 8 21 8.53726 21 9.2L21 22.8C21 23.4627 21.5373 24 22.2 24L25.8 24C26.4627 24 27 23.4627 27 22.8Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="24" cy="12" r="1" transform="rotate(180 24 12)" fill="black" stroke="black" strokeWidth="1.2" />
                <path
                    d="M21 22L21 10C21 8.89543 20.1046 8 19 8C17.8954 8 17 8.89543 17 10L17 22C17 23.1046 17.8954 24 19 24C20.1046 24 21 23.1046 21 22Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17 22L17 10C17 8.89543 16.1046 8 15 8C13.8954 8 13 8.89543 13 10L13 22C13 23.1046 13.8954 24 15 24C16.1046 24 17 23.1046 17 22Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 22L13 10C13 8.89543 12.1046 8 11 8C9.89543 8 9 8.89543 9 10L9 22C9 23.1046 9.89543 24 11 24C12.1046 24 13 23.1046 13 22Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9 22L9 10C9 8.89543 8.10457 8 7 8C5.89543 8 5 8.89543 5 10L5 22C5 23.1046 5.89543 24 7 24C8.10457 24 9 23.1046 9 22Z"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M24 24L24 26.6667" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25 21H23" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M25 18H23" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7 24L7 26.6667" stroke="black" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M9.90435 4.01725L9.52815 4.51516C9.36893 4.72589 9.47784 5.03075 9.73453 5.0929V5.0929C9.99634 5.15628 10.1028 5.47079 9.93342 5.68021L9.52046 6.19067"
                    stroke="black"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                />
                <path
                    d="M13.9044 4.01725L13.5282 4.51516C13.3689 4.72589 13.4778 5.03075 13.7345 5.0929V5.0929C13.9963 5.15628 14.1028 5.47079 13.9334 5.68021L13.5205 6.19067"
                    stroke="black"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                />
                <path
                    d="M17.9044 4.01725L17.5282 4.51516C17.3689 4.72589 17.4778 5.03075 17.7345 5.0929V5.0929C17.9963 5.15628 18.1028 5.47079 17.9334 5.68021L17.5205 6.19067"
                    stroke="black"
                    strokeWidth="0.8"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_7177_93583">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
